import React, {Component} from 'react';
import {connect} from "react-redux";
import {getLangs, notify} from "../../../../redux/actions";
import {withTranslation} from "react-i18next";
import {
    Spin,
    Col,
    Input,
    Modal,
    Form,
    Row,
    Button,
} from "antd";
import {noWhitespace} from "../../../../utils/rules";
import { PicCenterOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import ImgCrop from "antd-img-crop";
import { Upload } from "antd";
import JoditEditor from "jodit-react";

import admin from "../../../../const/api";

class EditAbout extends Component {
    formRef = React.createRef();
    editor = React.createRef();

    constructor(props) {
        super(props);
    }

    state = {
        spin: false,
        about: {},
        file: null,
        fileList: [],
        previewImage: "",
        previewVisible: false,
    };


     onChange = ({ fileList: newFileList }) => {
        this.setState({fileList:newFileList})
        if (newFileList.length <= 0) {
            this.setState({file:null})
        }
    };

     getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    }

     handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await this.getBase64(file.originFileObj);
        }
        this.setState({
            previewImage:file.url || file.preview,
            previewVisible:true
        })
    };

     setUploadFile = ({ onSuccess, onError, file }) => {
        let form_data = new FormData();
        const filename = Math.random(1, 999999) + Date.now() + file.name;
        form_data.append("image", file, filename);
        admin
            .post("file/upload/single/image", form_data, {
                headers: {
                    "content-type": "multipart/form-data",
                },
            })
            .then((res) => {
                this.setState({file: res.data.content.image_uuid})
                onSuccess(null, file);
            })
            .catch((err) => onError());
    };





     getPost = async () => {
        let obj = {};
        let abouts = {}
        await admin.get(`company/about`).then((res) => {
            if (res.data.content?.locales){
                let arr = [...this.state.fileList];
                this.setState({file:res?.data?.content?.picture_id});
                arr.push({ uid: res.data?.content?.picture_id, url: res.data.content?.picture?.path });
                this.setState({fileList:arr});
                res.data.content.locales.forEach((d) => {
                    obj[`about_${d.local}`] = d.about;
                    obj[`slogan_${d.local}`] = d.slogan;
                    abouts[`about_${d.local}`] = d.about;
                });
                obj[`link`] = res.data.content.link;
                this.setState({about:abouts});
                this.setState({spin:false});
                if(this.formRef.current !== null){
                    this.formRef.current.setFieldsValue(obj);
                }
            }
        });
    };


    componentDidMount() {
        this.props.getLangs()
        this.getPost()
        this.formRef.current.resetFields()
        this.setState({spin:true});
    }



    saveItem = async (values) => {
        let obj = {
            link:values.link,
            picture_id: this.state.file,
            locales: this.props.langs.map((l) => {
                return {
                    local: l.key,
                    about: values[`about_${l.key}`],
                    slogan: values[`slogan_${l.key}`],
                };
            }),
        };
        await admin
            .post(`/company/about`, obj)
            .then((res) => {
                this.props.notify("", true);
                this.formRef.current.resetFields();
                window.history.back();
            })
            .catch((err) => {
                notify(err.response, false);
            });
    };


    render() {
        let { t } = this.props;

        return (
            <div>
                <Row gutter={[16, 16]}>
                    <Col xs={24}>
                        <div className="border flex-between page-heading flex p-2 mt-0 bg-white">
                            <div className="page-name">
                                <PicCenterOutlined className="f-20 mr5-15" />
                                <span className="f-20 bold">Şirkət haqqında</span>
                            </div>
                            <Link
                                to={{
                                    pathname: `/about`,
                                    state: { locales: null },
                                }}
                            >
                                <Button type={"primary"}>{t("cancel")}</Button>
                            </Link>
                        </div>
                    </Col>
                    <Col xs={24}>
                        {(this.state.spin && !this.props.langs) ? (
                            <div className="flex animated fadeIn p-2 bg-white all-center">
                                <Spin size={"large"} />
                            </div>
                        ) : (
                            <div className="p-2 animated edit fadeInUp bg-white">
                                <Form ref={this.formRef} onFinish={this.saveItem} layout="vertical">
                                    <Row gutter={[8, 8]}>
                                        <Col md={16} xs={24}>
                                            <Form.Item
                                                label={'Youtube'}
                                                validateTrigger="onChange"
                                                name={`link`}
                                                rules={[noWhitespace(t("inputError"))]}
                                            >
                                                <Input className="w-100" />
                                            </Form.Item>

                                            <div>Şuar</div>
                                            {this.props.langs.map((l) => (
                                                <div key={l.id} className="form-lang">
                                                    <div className="">
                                                        {l.name}
                                                    </div>
                                                    <Form.Item
                                                        name={`slogan_${l.key}`}
                                                        validateTrigger="onChange"
                                                        rules={[noWhitespace(t("inputError"))]}
                                                    >
                                                        <Input className="w-100" />
                                                    </Form.Item>

                                                </div>
                                            ))}
                                        </Col>

                                        <Col md={8} xs={24}>
                                            <Form.Item
                                                validateTrigger="onChange"
                                                name={`photo`}
                                                required
                                            >
                                                <ImgCrop
                                                    className={"w-100"}
                                                    rotate
                                                    aspect={1523 / 400}
                                                    grid
                                                >
                                                    <Upload
                                                        action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                                        listType="picture-card"
                                                        fileList={this.state.fileList}
                                                        onChange={this.onChange}
                                                        onPreview={this.handlePreview}
                                                        customRequest={this.setUploadFile}
                                                        beforeUpload={null}
                                                    >
                                                        {this.state.fileList.length < 1 && "+ Yüklə"}
                                                    </Upload>
                                                </ImgCrop>
                                            </Form.Item>
                                        </Col>

                                        <Col md={24} sm={24} xs={24}>
                                            {this.props.langs.map((l) => (
                                                <div key={l.id} className="form-lang">
                                                    <div className="mb-10">
                                                        {l.name}
                                                    </div>
                                                    <Form.Item
                                                        name={`about_${l.key}`}
                                                        validateTrigger="onChange"
                                                        rules={[noWhitespace(t("inputError"))]}
                                                    >
                                                        <JoditEditor
                                                            ref={this.editor}
                                                            value={this.state.about[`about_${l.key}`]}
                                                            tabIndex={1} // tabIndex of textarea
                                                        />
                                                    </Form.Item>

                                                </div>
                                            ))}
                                        </Col>
                                        <Col xs={24}>
                                            <div className={"flex"}>
                                                <Button className={"mr-15"} htmlType="submit">
                                                    {t("save")}
                                                </Button>
                                                <Link
                                                    to={{
                                                        pathname: `/about`,
                                                        state: { locales: null },
                                                    }}
                                                >
                                                    <Button type={"primary"}>{t("cancel")}</Button>
                                                </Link>
                                            </div>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                        )}
                    </Col>
                </Row>

                <Modal
                    visible={this.state.previewVisible}
                    title={false}
                    footer={null}
                    onCancel={() => {
                       this.setState({previewVisible:false})
                    }}
                >
                    <img alt="example" style={{ width: "100%" }} src={this.state.previewImage} />
                </Modal>
            </div>
        );
    }
}


const mapStateToProps = ({ langs }) => {
    return {
        langs: langs,
    };
};

const exp = withTranslation()(EditAbout);
export default connect(mapStateToProps, { notify, getLangs })(exp);
